import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import { headerSty, contentSty } from "../table-styles";
import { Box, Skeleton, Typography } from "@mui/material";
import { Dot } from "../UIElements/svgIcons";
import { useNavigate } from "react-router-dom";
import { ScheduleContentsTableProps } from "../../interface/schedule";
import {
  formatDate,
  formatDateAndTimeFromString,
  formatDateFromString,
  formatTime,
  limitToSeven,
} from "../../utils/url-id";
import { TmesheetEmpStatus } from "./Table";

export default function HistoryTable({ historyList, loading }: any) {
  const theme = useTheme();
  const navigate = useNavigate();
  const headStyles = { ...headerSty, color: "#93A5D8" };
  const contentStyles = { ...contentSty };

  const [openRow, setOpenRow] = React.useState<number | null>(null); // Track which row is open

  const handleToggleOpen = (rowId: number) => {
    setOpenRow((prevOpenRow) => (prevOpenRow === rowId ? null : rowId));
  };
  
  const getColor = (text: string): string => {
    if (text === "Pending") return theme.palette.ascent.main;
    else if (text === "Swapped") return theme.palette.primary.main;
    else {
      return theme.palette.ascent.main;
    }
  };
  const getBg = (text: string): string => {
    if (text === "Pending") return theme.palette.ascent.light;
    else if (text === "Swapped") return theme.palette.lightBlue.main;
    else {
      return theme.palette.ascent.light;
    }
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        my: 1,
        boxShadow: "none",
        width: "96%",
        mx: "auto",
        minHeight: 300,
      }}
    >
      <Table
        sx={{
          minWidth: 650,
          boxShadow: "none",
          my: 1,
          paddingRight: 2,
        }}
        aria-label="simple table"
      >
        <TableHead sx={{ paddingX: 2 }}>
          <TableRow>
            <TableCell sx={{ ...headStyles, width: "15%" }}>Date</TableCell>
            <TableCell sx={{ ...headStyles, width: "15%" }}>Shift</TableCell>
            <TableCell sx={{ ...headStyles }}>Clock in</TableCell>
            <TableCell sx={{ ...headStyles }}>Clock out</TableCell>
            <TableCell sx={{ ...headStyles }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {historyList.map((row: any, index: number) => (
            <TableRow
              key={row?._id}
              onClick={() => navigate(`/timesheet/${row?._id}`)}
            >
              <TableCell sx={contentStyles}>
                {formatDateFromString(row?.created_at)}
              </TableCell>
              <TableCell sx={{ ...contentStyles }}>
                {limitToSeven(row?.shift)}
              </TableCell>
              <TableCell sx={{ ...contentStyles }}>
                {formatDateAndTimeFromString(row?.clock_in_time)}
              </TableCell>
              <TableCell sx={{ ...contentStyles }}>
                {formatDateAndTimeFromString(row?.clock_out_time)}
              </TableCell>
              <TableCell sx={{ ...contentStyles }}>
                <TmesheetEmpStatus status={row?.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {historyList?.length === 0 && !loading && (
        <Box
          sx={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, color: theme.palette.neutral.main }}
          >
            No Timesheet Available.
          </Typography>
        </Box>
      )}
      {loading && (
        <Box sx={{ width: "96%", mx: "auto" }}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
        </Box>
      )}
    </TableContainer>
  );
}

const TableDots: React.FC<{
  rowId: number;
  isOpen: boolean;
  toggleOpen: (id: number) => void;
}> = ({ rowId, isOpen, toggleOpen }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(!open);
  };
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        onClick={handleOpen}
        sx={{
          cursor: "pointer",
          width: "20px",
        }}
      >
        <Dot />
      </Box>
      {open && (
        <Box
          sx={{
            background: "#b0bee3",
            position: "absolute",
            top: 18,
            right: 0,
            borderRadius: "12px",
            padding: "8px 12px",
            zIndex: 30,
            width: 80,
            height: 80,
            cursor: "pointer",
          }}
        >
          {/* <Stack>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
                color: "#1E1E1E",
                my: 1,
              }}
            >
              Approve
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
                color: "#1E1E1E",
                my: 1,
              }}
            >
              Decline
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
                color: "#1E1E1E",
                my: 1,
              }}
            >
              Flag
            </Typography>
          </Stack> */}
        </Box>
      )}
    </Box>
  );
};
